import { Injectable } from '@angular/core';
import { BaseService } from 'cre-ng';

import { DriverSearch, DriverSearchParams } from './search.models';

@Injectable()
export class SearchService extends BaseService {
  driverSearch(params: DriverSearchParams) {
    const httpHeaders = this.getHttpHeaders();
    const requestOptions = { headers: httpHeaders };
    return this.httpClient
      .post<DriverSearch[]>(this.serviceUrl + '/driverwig/driverSearch/', params, requestOptions)
      .toPromise();
  }

  getFleets(user: string): Promise<string[]> {
    const httpHeaders = this.getHttpHeaders();
    const requestOptions = { headers: httpHeaders };
    return this.httpClient
      .get<string[]>(this.serviceUrl + `/driverwig/fleets/${user}/`, requestOptions)
      .toPromise();
  }

  protected getEndPoint(): string {
    return '/driverwig/api/v1';
  }
}
